// extracted by mini-css-extract-plugin
export default {"container":"StormStrategySurveys_container__30Xh6","rating":"StormStrategySurveys_rating__iNYa8"};